var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMalawi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_653)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.10352e-05 20C6.10352e-05 22.4464 0.440139 24.7899 1.24405 26.9565L20.0001 27.8261L38.7561 26.9566C39.5601 24.7899 40.0001 22.4464 40.0001 20C40.0001 17.5536 39.5601 15.2102 38.7561 13.0436L20.0001 12.174L1.24405 13.0435C0.440139 15.2102 6.10352e-05 17.5536 6.10352e-05 20H6.10352e-05Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9999 3.05176e-05C11.4006 3.05176e-05 4.06976 5.42753 1.2439 13.0435H38.756C35.9301 5.42753 28.5992 3.05176e-05 19.9999 3.05176e-05V3.05176e-05Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.7559 26.9565H1.2439C4.06976 34.5725 11.4006 40.0001 19.9999 40.0001C28.5992 40.0001 35.9301 34.5725 38.7559 26.9565Z",
    fill: "#496E2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9778 9.56525L23.5353 8.41635L24.836 6.0508L22.1836 6.55822L21.8475 3.87869L20 5.8494L18.1526 3.87869L17.8164 6.55822L15.1642 6.0508L16.4649 8.41635L14.0223 9.56525H25.9778Z",
    fill: "#D80027"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_653"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMalawi);
export default __webpack_public_path__ + "static/media/malawi.4aa052eeef16826e3814ff5cb77c6bcd.svg";
export { ForwardRef as ReactComponent };